import './index.scss';

const MessageBox = {

  install(Vue) {
    // <div class="text">${message}</div> 这里不要加空格 CSS  white-space : pre-line;
    const createMessageHtml = function (message) {
      return `<div class="g-message-box">
        <div class="iconfont icon-36">
        </div>
        <div class="text">${message}</div>
      </div>`;
    };
    Vue.prototype.$$confirm = function (message, title = '提示', options) {
      let args = [...arguments];
      let html = createMessageHtml(message);
      args[0] = html;
      if (typeof title === 'object' && !options) {
        options = title;
        options.dangerouslyUseHTMLString = true;
        return this.$confirm.apply(this, [html, options]);
      } else if (typeof title === 'string') {
        options = options || {};
        options.dangerouslyUseHTMLString = true;
        return this.$confirm.apply(this, [html, title, options]);
      } else if (!title && options) {
        options.dangerouslyUseHTMLString = true;
        return this.$confirm.apply(this, [html, options]);
      }
      return this.$confirm.apply(this, args);
    };

    Vue.prototype.$$alert = function (message, options) {
      return this.$$confirm.call(this, message, Object.assign({
        showConfirmButton: false,
        showCancelButton: false
      }, options)).catch(e =>{});
    };


  }

};

export default MessageBox;
